import colors from "../../../../../Constants/colors";

export const usageContainer = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  backgroundColor: "var(--colorPrimary)",
  height: "auto",
  width: "95%",
  boxShadow: "0px 0px 60px rgba(58, 74, 255, 0.2)",
  // margin: "40px 0px",
  padding: "40px",
};

export const toggleButtonsGroupLayout = {
  backgroundColor: "#9595958b",
  "& .MuiToggleButton-root": {
    "&:hover": {
      backgroundColor: "lightblue", // Change background color on hover
    },
    "&.Mui-selected": {
      backgroundColor: "#443dff", // Change background color of selected button
      color: "#fff", // Change text color of selected button
      "&:hover": {
        backgroundColor: "#443dff", // Keep the selected button color the same on hover
      },
    },
  },
};

export const navBarContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px",
  backgroundColor: "var(--colorPrimary)",
  width: "100%",
  borderBottom: "2px solid gray",
  mb: 4,
};

export const monthNavigatorContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "20px",
  border: `2px solid ${colors.bgBlue}`,
  backgroundColor: colors.bgBlue,
  color: "white",
};

export const stackedBarsContainer = {
  width: "100%",
  mt: 4,
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "column",
  color: colors.white,
  flexBasis: "50%",
};

export const graphsDisplayContainer = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
};

export const selectBaseStyles = {
  backgroundColor: colors.secondaryBlue,
  borderRadius: "5px",
  color: colors.extremeWhite,
  "& .MuiSelect-icon": {
    color: colors.extremeWhite,
  },
  "& .MuiInputBase-input": {
    color: colors.extremeWhite,
  },
  "& .Mui-focused .MuiInputLabel-root": {
    color: colors.extremeWhite,
  },
  "&:before, &:after": {
    border: `1px solid ${colors.primaryBlue}`,
  },
  "&:hover": {
    backgroundColor: colors.secondaryBlue, // Maintain background color on hover
    color: colors.extremeWhite,
  },
  "&.Mui-focused": {
    backgroundColor: colors.secondaryBlue, // Maintain background color on focus
    color: colors.extremeWhite,

    "& .MuiSelect-icon": {
      color: colors.extremeWhite, // Ensure the icon color remains consistent
    },
  },
};

export const menuItemStyles = {
  backgroundColor: "transparent",
  color: colors.extremeWhite,
  fontWeight: "normal",
  "&:hover": {
    backgroundColor: colors.primaryBlue,
    color: colors.extremeWhite,
  },
  "&.Mui-selected": {
    backgroundColor: `${colors.secondaryBlue} !important`,
    color: `${colors.extremeWhite} !important`,
    "&:hover": {
      backgroundColor: `${colors.primaryBlue} !important`,
      color: `${colors.extremeWhite} !important`,
    },
  },
};

export const menuContainerStyles = {
  backgroundColor: colors.extremeBlue,
  boxShadow: `0px 4px 12px ${colors.primaryBlue}`,
  opacity: 1,
  backdropFilter: "none",
  color: colors.extremeWhite,
};
